/**
 * Created by pajicv on 9/26/18.
 */
import React from 'react';
import { Base64 } from 'js-base64';
import { Stepper, Step, StepButton, Button, Typography } from '@material-ui/core';
import ProjectTitle from '../../components/ProjectSetup/ProjectTitle';
import ProjectTargetGroups from '../../components/ProjectSetup/ProjectTargetGroups';
import ProjectUseCases from '../../components/ProjectSetup/ProjectUseCases';
import ProjectMembers from '../../components/ProjectSetup/ProjectMembers';
import ProjectDocuments from '../../components/ProjectSetup/ProjectDocuments';
import validator from 'validator';
import { sendEmail } from '../../firebase/functions';
import {
    updateProjectTitle, createEmptyTargetGroup, addTargetGroupToProject, updateTargetGroupName, updateTargetGroupDescription, addUserToProject,
    createEmptyUseCase, addUseCaseToProject, updateUseCaseName, updateUseCaseDescription, updateDocumentsTags,
    initTargetGroup, initUseCase, deleteUseCase, deleteTargetGroup, deleteDocument, updateDocumentTags, updateDocumentDescription, initDocument,
    updateProjectDate, deleteMember, removeAssignedTasksForDeletedUser, saveTargetGroup, saveUseCase
} from '../../firebase/db';
import { getNumberOfMyOpenTasksOnProject } from '../../firebase/db/project';
import { uploadProjectDoc } from '../../firebase/storage';
import { DASHBOARD } from '../routes';
import swal from 'sweetalert2';
import { APP_URL } from '../../firebase-config';

class ProjectMain extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            steps: ['Projekt info', 'Zielgruppen', 'Use Cases', 'Team Mitglieder einladen', 'Upload Dokumente'],
            projectMemberToInvite: {
                role: 'worker',
                email: '',
                name: ''
            }
        };
    }

    componentDidMount() {
        const { projectId } = this.props;

        this.setState({ project: { projectId } });
    }

    handleNext = () => {
        const { activeStep } = this.state;
        this.setState({
            activeStep: activeStep + 1,
        }, () => {
            const { activeStep, steps } = this.state;
            if (activeStep === steps.length) {
                this.props.onClose();
            }
        });
    };

    handleBack = () => {
        const { activeStep } = this.state;
        this.setState({
            activeStep: activeStep - 1,
        });
    };

    handleReset = () => {
        this.setState({
            activeStep: 0,
        });
    };

    handleStep = step => () => {
        this.setState({
            activeStep: step,
        });
    };

    handleCancel = () => {
        this.props.onClose();
    }

    handleAddTargetGroup = () => {
        const { project: { projectId } } = this.state;
        const targetGroupId = createEmptyTargetGroup();
        addTargetGroupToProject(projectId, targetGroupId)
            .then((result) => {
                return this.setState(state => ({ targetGroups: [...state.targetGroups, { targetGroupId, name: '', description: '' }] }))
            });
    };

    handleSaveTargetGroup = (targetGroupId, name, description) => {
        const { project: { projectId } } = this.state;
        saveTargetGroup(projectId, name, description);
    };

    handleAddTargetGroup_v2 = () => {
        const { project: { projectId } } = this.state;
        initTargetGroup()
            .then((targetGroupId) => {
                return addTargetGroupToProject(projectId, targetGroupId);
            });
    };

    handleAddUseCases = () => {
        const { project: { projectId } } = this.state;
        const useCaseId = createEmptyUseCase();
        addUseCaseToProject(projectId, useCaseId)
            .then(() => {
                return this.setState(state => ({ useCases: [...state.useCases, { useCaseId, name: '', description: '' }] }));
            });
    };
    handleSaveUseCase = (useCaseId, name, description) => {
        const { project: { projectId } } = this.state;
        saveUseCase(projectId, name, description);
    };

    handleAddUseCases_v2 = () => {
        const { project: { projectId } } = this.state;
        initUseCase()
            .then((useCaseId) => {
                addUseCaseToProject(projectId, useCaseId);
            });
    };

    handleAddDocument = (accepted) => {
        const { project: { projectId } } = this.state;
        const { title } = this.props.project || {};
        const { auth } = this.props;
        Promise.all(accepted.map((acc) => {
            return initDocument(projectId, acc.name, auth.email)
                .then((id) => {
                    acc['id'] = id;
                    updateDocumentsTags(id, title, acc.name.split('.').pop());
                    return uploadProjectDoc(id, acc);
                });
        }))
    }

    handleDeleteTargetGroup = (index) => {
        this.setState((state) => {
            const { targetGroups } = state;
            targetGroups.splice(index, 1);
            return { ...state, targetGroups };
        });
    };

    handleDeleteTargetGroup_v2 = (targetGroupId) => {
        const { project: { projectId } } = this.state;
        deleteTargetGroup(projectId, targetGroupId);
    };

    handleDeleteUseCase = (index) => {
        this.setState((state) => {
            const { useCases } = state;
            useCases.splice(index, 1);
            return { ...state, useCases };
        });
    };

    handleDeleteUseCase_v2 = (useCaseId) => {
        const { project: { projectId } } = this.state;
        deleteUseCase(projectId, useCaseId)
    };

    handleDeleteDocument = (documentId, name) => {
        const { onDialogOpen } = this.props;
        const { project: { projectId } } = this.state;
        onDialogOpen(true);
        swal({
            title: `Wollen Sie das Dokument ${name} wirklich löschen?`,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#54be89',
            cancelButtonColor: '#ef6920',
            confirmButtonText: 'OK',
            cancelButtonText: 'CANCEL'
        }).then((result) => {
            if (result.value) {
                deleteDocument(projectId, documentId)
                    .then(() => {
                        return swal(
                            'Deleted!',
                            'The member has been deleted.',
                            'success'
                        )
                            .then(() => onDialogOpen(false))
                    })
                    .catch(console.log);
            }
        });
    };

    handleTextFieldChange = (propertyName, index, field, value) => {
        this.setState((state) => {
            const property = state[propertyName];
            if (typeof index !== 'undefined') {
                property[index][field] = value;
            } else {
                property[field] = value;
            }
            return { ...state, property };
        });
    };

    handleAddMemberToInvite = () => {
        this.setState({ projectMemberToInvite: { role: '', email: '', name: '' } });
    };

    handleInviteMember = (newMember) => {

        const { auth } = this.props;
        const { project: { projectId } } = this.state;

        if (validator.isEmpty(newMember.role) || validator.isEmpty(newMember.email) || !validator.isEmail(newMember.email)) {
            return;
        }

        sendEmail({
            from: auth.email,
            to: newMember.email,
            subject: 'Invitation to project',
            html: `<p>
                     You have been invited by ${auth.email} to the project. <br/> 
                     You can access the project at <a href="${APP_URL}">${APP_URL}</a>
                   </p>`
        })
            .then(() => {
                return addUserToProject(projectId, newMember.email, newMember.role)
            })
            .catch((err) => {
                console.log(err);
            });

    };

    handleTitleEndEditing = (title) => {
        const { projectId } = this.props;
        updateProjectTitle(projectId, title);
    };

    handleTargetGroupNameBlur = (targetGroupId, name) => {
        updateTargetGroupName(targetGroupId, name);
    };

    handleTargetGroupDescriptionBlur = (targetGroupId, description) => {
        updateTargetGroupDescription(targetGroupId, description);
    };

    handleUseCaseNameBlur = (useCaseId, name) => {
        updateUseCaseName(useCaseId, name);
    };

    handleUseCaseDescriptionBlur = (useCaseId, description) => {
        updateUseCaseDescription(useCaseId, description);
    };

    handleDocumentTagsBlur = (docId, tags) => {
        updateDocumentTags(docId, tags);
    }

    handleDocumentDescBlur = (docId, description) => {
        updateDocumentDescription(docId, description);
    }

    handleDateChange = (field, value) => {
        const { projectId } = this.props;
        updateProjectDate(projectId, field, value)
            .then(console.log)
            .catch(console.log);
    };

    handleDeleteMember = (email, role) => {
        const { projectId, onDialogOpen } = this.props;
        getNumberOfMyOpenTasksOnProject(projectId, email)
            .then(numberOfTasks => {
                if (numberOfTasks > 0) {
                    onDialogOpen(true);
                    swal({
                        title: 'Are you sure you want to delete member?',
                        text: "The user have the open tasks",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {
                        if (result.value) {
                            deleteMember(projectId, Base64.encode(email), role)
                                .then(() => {
                                    return swal(
                                        'Deleted!',
                                        'The member has been deleted.',
                                        'success'
                                    )
                                        .then(() => onDialogOpen(false))
                                })
                                .catch(console.log);
                        } else {
                            onDialogOpen(false);
                        }
                    });
                } else {
                    onDialogOpen(true);
                    swal({
                        title: `Wollen Sie ${email} wirklich aus dem Projekt Team entfernen?`,
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#54be89',
                        cancelButtonColor: '#ef6920',
                        confirmButtonText: 'OK',
                        cancelButtonText: 'CANCEL'
                    }).then((result) => {
                        if (result.value) {
                            deleteMember(projectId, Base64.encode(email), role)
                                .then(() => {
                                    return swal(
                                        'Deleted!',
                                        'The member has been deleted.',
                                        'success'
                                    )
                                        .then(() => onDialogOpen(false))
                                })
                                .catch(console.log);
                        }
                    });

                }
            });
    };

    getStepContent(stepIndex) {
        const { targetGroups, title, useCases, members, documents, startDate, endDate } = this.props.project || {};
        const { onDialogOpen } = this.props;
        switch (stepIndex) {
            case 0:
                return <ProjectTitle
                    title={title}
                    onEndEditing={this.handleTitleEndEditing}
                    onDateChange={this.handleDateChange}
                    startDate={startDate}
                    endDate={endDate}
                />;
            case 1:
                return <ProjectTargetGroups
                    targetGroups={targetGroups}
                    onAddTargetGroup={this.handleAddTargetGroup_v2}
                    onDeleteTargetGroup={this.handleDeleteTargetGroup_v2}
                    onTargetGroupNameBlur={this.handleTargetGroupNameBlur}
                    onTargetGroupDescriptionBlur={this.handleTargetGroupDescriptionBlur}
                    onSaveTargetGroup={this.handleSaveTargetGroup}
                />
            case 2:
                return <ProjectUseCases
                    useCases={useCases}
                    onAddUseCase={this.handleAddUseCases_v2}
                    onDeleteUseCase={this.handleDeleteUseCase_v2}
                    onUseCaseNameBlur={this.handleUseCaseNameBlur}
                    onUseCaseDescriptionBlur={this.handleUseCaseDescriptionBlur}
                    onSaveUseCase={this.handleSaveUseCase}
                />
            case 3:
                return <ProjectMembers
                    members={members}
                    onInviteMember={this.handleInviteMember}
                    onDeleteMember={this.handleDeleteMember}
                />;
            case 4:
                return <ProjectDocuments
                    documents={documents}
                    onTagsOpen={onDialogOpen}
                    handleAddDocument={this.handleAddDocument}
                    onTagsChange={this.handleDocumentTagsBlur}
                    onDescriptionChange={this.handleDocumentDescBlur}
                    onDeleteDocument={this.handleDeleteDocument} />;
            default:
                return 'Define project name';
        }
    }

    render() {
        const { activeStep, steps } = this.state;
        const { title } = this.props.project || {};
        return (
            <div style={{
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100%'
            }}>
                <Typography
                    variant="display2"
                    color="primary"
                    gutterBottom
                    style={{ flex: 1, paddingTop: 20 }}
                >
                    {title ? title : 'Projekt setup'}
                </Typography>
                <Stepper
                    alternativeLabel
                    nonLinear
                    activeStep={activeStep}
                    style={{ flex: 2 }}
                >
                    {steps.map((label, index) => (
                        <Step key={label}>
                            <StepButton
                                onClick={this.handleStep(index)}
                            >
                                {label}
                            </StepButton>
                        </Step>
                    ))}
                </Stepper>
                <div style={{ flex: 9, overflowY: 'scroll' }}>{this.getStepContent(activeStep)}</div>
                <div style={{
                    width: '100%',
                    bottom: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#ccc',
                    flex: 1
                }}
                >
                    <Button
                        style={{ margin: 10 }}
                        disabled={activeStep === 0}
                        onClick={this.handleBack}
                        variant="contained"
                        color="primary"
                    >
                        Zurück
                            </Button>
                    <Button
                        style={{ margin: 10 }}
                        color="secondary"
                        onClick={this.handleCancel}
                    >
                        Schliessen
                            </Button>
                    <Button variant="contained" color="primary" onClick={this.handleNext} style={{ margin: 10 }}>
                        {activeStep === steps.length - 1 ? 'Fertig' : 'Weiter'}
                    </Button>
                </div>
            </div>
        );
    }
}

export default ProjectMain;



// WEBPACK FOOTER //
// ./src/routes/ProjectSetup/ProjectMain.js